export { default as default } from '../modules/flags'


//////////////////
// WEBPACK FOOTER
// /app/node_modules/react-phone-number-input/flags/index.js
// module id = 844
// module chunks = 1 2 3 4